import React from "react";
import styled from "styled-components";
import { breakpoints, imgix } from "../../styles/variables";
import MailButton from "./MailButton";
import ImgixImg from "../helpers/ImgixImg";

const ItemElem = styled.article`
  text-align: left;
  margin-bottom: 40px;

  .job {
    font: 18px / 24px "FS Medium";
    margin-bottom: 10px;
    white-space: pre-line;
  }

  .name {
    font: 20px / 26px "FS Medium";
    margin-bottom: 6px;
  }

  a,
  p {
    display: block;
    font: 18px / 22px "FS Regular";
    text-decoration: none;
    margin-bottom: 10px;
  }

  div.text p {
    font: 16px / 20px "FS Regular";
    text-decoration: none;
  }

  @media screen AND (min-width: 1024px) {
    margin-bottom: 0;
  }

  @media screen AND (min-width: ${breakpoints.desktop}px) {
    .job {
      font: 22px / 28px "FS Regular";
    }

    .name {
      font: 24px / 28px "FS Medium";
      margin-bottom: 6px;
    }

    a,
    p {
      font: 22px / 30px "FS Regular";
      margin-bottom: 18px;
    }
  }
`;

const MitarbeiterImage = styled.div`
  margin: 0 auto 20px;
  max-width: 424px;

  img {
    display: block;
    width: 100%;
    height: auto;
  }
`;

const MitarbeiterImagePlaceholder = styled.div`
  aspect-ratio: 4 / 5;
  background: #f2f2f2;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 40%;
    max-width: none;
  }
`;

const MitarbeiterSchlichtItem = ({ color, content }) => (
  <ItemElem>
    <MitarbeiterImage>
      {content.bild.length > 0 ? (
        <ImgixImg
          src={content.bild[0].url}
          imgixParams={imgix.mitarbeiterSchlichtImage}
        />
      ) : (
        <MitarbeiterImagePlaceholder>
          <img
            src="/assets/gestaltungselemente/platzhalter-mitarbeiter.svg"
            alt=""
          />
        </MitarbeiterImagePlaceholder>
      )}
    </MitarbeiterImage>
    {content.mitarbeitername ? (
      <h3 className="name">{content.mitarbeitername}</h3>
    ) : (
      ""
    )}
    {content.job ? <h4 className="job">{content.job}</h4> : ""}
    {content.telefon && (
      <a href={"tel:" + content.telefon} title="Telefon Link">
        {content.telefon}
      </a>
    )}
    {content.text ? (
      <div
        dangerouslySetInnerHTML={{ __html: content.text }}
        className="text"
      ></div>
    ) : (
      ""
    )}
    {content.email ? (
      <MailButton color={color} email={content.email} align="left" />
    ) : (
      ""
    )}
  </ItemElem>
);

export default MitarbeiterSchlichtItem;
